<template>
  <div class="dashboard-admin-sidebar-hub-ui">
    <div v-show="isAdminHubShown">
      <DashboardAdminSidebarNav @navigate="emitNavigate" @go-back="handleGoBack" />
    </div>
    <div v-show="!isAdminHubShown">
      <DashboardSidebarContentSection>
        <VBtn class="admin-hub" flat @click="showAdminHub">Admin Hub</VBtn>
      </DashboardSidebarContentSection>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  // Types
  import type { RouteLocationNormalizedLoaded } from 'vue-router';

  // Components
  import DashboardAdminSidebarNav from '~/modules/dashboard/admin/sidebar/nav/DashboardAdminSidebarNav.vue';
  import DashboardSidebarContentSection from '~/modules/dashboard/sidebar/content-section/DashboardSidebarContentSection.vue';
  import VBtn from '~/misc/v-btn';

  const route: RouteLocationNormalizedLoaded = useRoute();

  const { isAdminPath: checkIsAdminPath } = useIsAdminPath();

  const emit = defineEmits<{
    (e: 'navigate', route: RouteLocationNormalizedLoaded | string): void;
  }>();

  const isAdminHubShown: Ref<boolean> = ref<boolean>(false);
  const isAdminPath: Ref<boolean> = ref<boolean>(false);

  const showAdminHub = () => {
    isAdminHubShown.value = true;
  };

  const hideAdminHub = () => {
    isAdminHubShown.value = false;
  };

  const handleGoBack = () => {
    isAdminPath.value ? emitNavigate('/') : hideAdminHub();
  };

  const emitNavigate = (route: RouteLocationNormalizedLoaded | string) => emit('navigate', route);

  watch(
    () => route.path,
    (newValue: string, prevValue: string | undefined) => {
      if (newValue === prevValue) return;

      isAdminPath.value = checkIsAdminPath(newValue);

      isAdminPath.value ? showAdminHub() : hideAdminHub();
    },
    {
      immediate: true,
    }
  );
</script>
